import { render } from "./SearchTags.vue?vue&type=template&id=f274e992&scoped=true"
import script from "./SearchTags.vue?vue&type=script&lang=js"
export * from "./SearchTags.vue?vue&type=script&lang=js"

import "./SearchTags.vue?vue&type=style&index=0&id=f274e992&scoped=true&lang=css"

import exportComponent from "D:\\lawstudio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f274e992"]])

export default __exports__